import React from "react";
import Input from "Components/UI/Input";
import { useFormContext } from "react-hook-form";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import { MinusCircle, PlusCircle, Trash } from "react-feather";

const dateFormat = "YYYY-MM-DD";
import dayjs from "dayjs";
import { DatePicker } from "antd";
const { RangePicker } = DatePicker;
const disabledDate = (current) => {
  return current < dayjs().subtract(1, "day").endOf("day");
};

const disabled7DaysDate = (current, { from }) => {
  if (from) {
    return Math.abs(current.diff(from, "days")) >= 90;
  }
  return false;
};

const boolStatus = [
  { id: "1", label: "Yes", value: true },
  { id: "2", label: "No", value: false },
];

const ShiftRotationModal = ({
  mode = "I",
  onSubmit,
  show = false,
  handleClose,
  groupData,
  shiftData,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    watch,
    trigger,
    setValue,
    getValues,
  } = useFormContext();

  const shiftRotation = watch("shiftRotation") || [{ group: "", shift: "" }];
  


  const groupsOptions = Array.isArray(groupData)
    ? groupData
        // .filter((r) => r.isActive)
        .map((r) => ({ label: r.groupName, value: r.groupCode }))
    : [];

  const shiftOptions = Array.isArray(shiftData)
    ? shiftData.map((r) => ({
        label: `${r.shiftName} - (${r.locationCode})`,
        value: r.shiftPolicyID,
      }))
    : [];

  const addShiftRow = () => {
    const newRow = { group: "", shift: "" };
    setValue("shiftRotation", [...shiftRotation, newRow]);
  };

  const removeShiftRow = (index) => {
    const updatedRows = shiftRotation.filter((_, i) => i !== index);
    setValue("shiftRotation", updatedRows);
    trigger("shiftRotation");
  };

  console.log(errors);

  return (
    <Modal show={show} onHide={handleClose} animation={true} centered>
      <Modal.Header
        className="modal-header border-0 custom-modal-header"
        style={{ justifyContent: "space-between" }}
      >
        <div className="page-title">
          <h4>{mode === "I" ? "Add Shift Rotation" : "Edit Shift Rotation"}</h4>
        </div>
        <button type="button" className="close" onClick={handleClose}>
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)} className="needs-validation">
          <div className="form-row">
            <div className="mb-3">
              {/* <Input
                name="scheduleFromDate"
                label="From Date"
                placeholder="From Date"
                className={`form-control ${
                  errors.scheduleFromDate ? "is-invalid" : ""
                }`}
                labelClassName="form-label"
                type="date"
                required={true}
                requiredMessage="From Date is required"
                dateFormat={dateFormat}
                defaultValue={
                  dayjs(watch("scheduleFromDate"), dateFormat) || ""
                }
                onChange={(date) => {
                  setValue(
                    "scheduleFromDate",
                    date ? dayjs(date).format(dateFormat) : null
                  );
                  setValue(
                    "scheduleToDate",
                    date ? dayjs(date).add(6, "day").format(dateFormat) : null
                  );

                  trigger("scheduleFromDate");
                  trigger("scheduleToDate");
                }}
                getPopupContainer={(trigger) => trigger.parentNode}
                disabledDate={disabledDate}
              /> */}
              <RangePicker
                // disabledDate={disabled7DaysDate}
                className="form-control"
                style={{ display: "flex" }}
                onChange={(date, dateFormat) => {
                  setValue("scheduleFromDate", dateFormat[0]);
                  setValue("scheduleToDate", dateFormat[1]);
                }}
                defaultValue={[
                  dayjs(watch("scheduleFromDate"), "YYYY-MM-DD"),
                  dayjs(watch("scheduleToDate"), "YYYY-MM-DD"),
                ]}
                getPopupContainer={(trigger) => trigger.parentNode}
                disabledDate={(current) => {
                  return current && current < dayjs().startOf("day");
                }}
                // format="DD-MM-YYYY"
              />
            </div>
            {/* <div className="mb-3">
              <Input
                name="scheduleToDate"
                label="To Date"
                placeholder="To Date"
                className={`form-control ${
                  errors.scheduleToDate ? "is-invalid" : ""
                }`}
                labelClassName="form-label"
                type="date"
                required={true}
                requiredMessage="To Date is required"
                dateFormat={dateFormat}
                defaultValue={dayjs(watch("scheduleToDate"), dateFormat) || ""}
                getPopupContainer={(trigger) => trigger.parentNode}
                disabledDate={
                  (current) =>
                    current <=
                    dayjs(new Date(watch("scheduleFromDate"))).subtract(
                      1,
                      "day"
                    ) //.endOf("day")
                }
              />
            </div> */}
            <div className="mb-3">
              {mode === "I" && (
                <div className="d-flex justify-content-between">
                  <label className="form-label">Shift Rotation</label>
                  <button
                    type="button"
                    className="btn btn-icon btn-outline-primary rounded-pill"
                    onClick={addShiftRow}
                  >
                    <PlusCircle />
                  </button>
                </div>
              )}
              {shiftRotation.map((_, index) => (
                <div className="row mb-2" key={index}>
                  <div className="col-md-5">
                    <Input
                      name={`shiftRotation[${index}].group`}
                      type="commonSelect"
                      placeholder="Group"
                      className={`form-control  ${
                        errors.shiftRotation?.[index]?.group ? "is-invalid" : ""
                      }`}
                      label="Group"
                      labelClassName="form-label"
                      optionData={groupsOptions}
                      required={false}
                      onChange={(selectedOption) => {
                        setValue(
                          `shiftRotation[${index}].group`,
                          selectedOption || ""
                        );
                        trigger(`shiftRotation[${index}].group`);
                      }}
                      defaultValue={watch(`shiftRotation?.[${index}]?.group`)}
                      getPopupContainer={(trigger) => trigger.parentNode}
                    />
                    {errors.shiftRotation?.[index]?.group && (
                      <div className="invalid-feedback">
                        {errors.shiftRotation?.[index].group?.message ||
                          "Invalid input"}
                      </div>
                    )}
                  </div>
                  <div className="col-md-5">
                    <Input
                      name={`shiftRotation[${index}].shift`}
                      type="commonSelect"
                      placeholder="Shift"
                      className={`form-control ${
                        errors.shiftRotation?.[index]?.shift ? "is-invalid" : ""
                      }`}
                      label="Shift"
                      labelClassName="form-label"
                      optionData={shiftOptions}
                      required={false}
                      onChange={(selectedOption) => {
                        setValue(
                          `shiftRotation[${index}].shift`,
                          selectedOption || ""
                        );
                        trigger(`shiftRotation[${index}].shift`);
                      }}
                      defaultValue={watch(`shiftRotation?.[${index}]?.shift`)}
                      getPopupContainer={(trigger) => trigger.parentNode}
                      dropdownStyle={{
                        minWidth: "fit-content",
                      }}
                    />
                    {errors.shiftRotation?.[index]?.shift && (
                      <div className="invalid-feedback">
                        {errors.shiftRotation[index].shift?.message ||
                          "Invalid input"}
                      </div>
                    )}
                  </div>
                  <div className="col-md-2 d-flex align-items-center">
                    <button
                      type="button"
                      className="btn btn-defalut"
                      onClick={() => removeShiftRow(index)}
                      style={{ marginTop: "20px" }}
                    >
                      <MinusCircle className="me-2" />
                    </button>
                  </div>
                </div>
              ))}
            </div>
            <div className="mb-3">
              <Input
                name="remarks"
                label="Remarks"
                placeholder="Remarks"
                className={`form-control ${errors.remarks ? "is-invalid" : ""}`}
                labelClassName="form-label"
                type="text"
                required={true}
                requiredMessage="Remarks is required"
              />
            </div>
            <div className="mb-3">
              <Input
                name="isActive"
                type="select"
                placeholder="Status"
                className={`form-control ${
                  errors.isActive ? "is-invalid" : ""
                }`}
                label="Status"
                labelClassName="form-label"
                optionData={boolStatus}
                required={true}
                requiredMessage="Status is required"
                onChange={(selectedOption) => {
                  setValue(
                    "isActive",
                    selectedOption ? selectedOption.value : null
                  );
                  trigger("isActive");
                }}
              />
              {errors.isActive && (
                <div className="invalid-feedback">
                  {errors.isActive?.message || "Invalid input"}
                </div>
              )}
            </div>
          </div>
          <div className="text-end mt-5">
            <button type="submit" className="btn btn-primary">
              {mode === "I" ? "Add" : "Update"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

ShiftRotationModal.propTypes = {
  mode: PropTypes.oneOf(["I", "E"]),
  onSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  groupData: PropTypes.object,
  shiftData: PropTypes.object,
};

export default ShiftRotationModal;
